<template lang="html">
	<div style="width: 100%;">
		<!-- menu message input -->
		<v-menu v-model="menuInput" :position-x="x_menu_input" :position-y="y_menu_input" absolute offset-y>
			<v-list dense>
				<v-list-item v-for="(item, index) in ListBottomItem" :key="index" @click="emitListBottom(item)"
					:disabled="item.disabled">
					<v-list-item-title class="line-height-menu" :style="subFontSizeStyle">{{ item.text
						}}</v-list-item-title>
				</v-list-item>
			</v-list>
		</v-menu>
		<!-- chat box -->
		<a-mentions id="textsendmsg" ref="textareaChat" :loading="loading"
			:placeholder="statemember !== 'active' ? $t('ChatSide.textarea.inactive') : $t('ChatSide.textarea.normal')"
			v-model="msgSend" :style="subFontSizeStyle" :rows="rows" placement="top" @select="onSelect"
			@search="onSearch" @paste.prevent="onPaste" @contextmenu="showMenuInput"
			@keydown.enter="sendMessage($event, msgSend, '', 'text', '')"
			@keypress="sendMessage($event, msgSend, '', 'text', '')" :disabled="statemember !== 'active'">
			<a-mentions-option v-for="({ tokenuser, name, profilepicture: avatar }) in listfriend_filter"
				:key="tokenuser" :value="`${name}-${tokenuser}`">
				<v-avatar size="40" class="mr-5">
					<img v-if="avatar" :src="avatar" :alt="avatar" class="img-position mr-5"
						:id="`imgprofilechat-${tokenuser}`" v-on:error="setDefaultImageChat(tokenuser)">
					<img v-else :src="`${publicPath}/assets/img/default_profile/man-white.png`" alt=""
						class="img-position mr-5">
				</v-avatar>
				<span :style="subFontSizeStyle" class="ml-5 pl-5 icon-color-active" :id="tokenuser">{{ space_key }}{{
					name }}</span>
			</a-mentions-option>
		</a-mentions>
		<WarningDialog :WarningDialog="WarningDialog" :WarningDialogDetail="WarningDialogDetail"
			@emitWarning="emitWarning" @closeAlertDialog="closeAlertDialog" />
	</div>
</template>

<script>
// import ErrorDialog from '@/components/Alert/Error'
import WarningDialog from '@/components/Alert/Warning'

var _ = require('lodash')

export default {
	props: {
		subFontSizeStyle: Object,
		space_key: String,
		listfriend: Array,
		statemember: String,
		statusSendMsg: String,
		app_lang: String,
		typeRoom: String,
		ListMenuData: {},
		reply_status: Boolean,
		new_msgSend: String,
		tokenroom: String,
		emitEmoji: Object,
	},
	components: {
		// ErrorDialog,
		WarningDialog,
	},
	data() {
		return {
			publicPath: process.env.VUE_APP_BASE_PATH,
			stylechat: {
				"--Chat-Background": "white",
				"--Chat-HeaderColor": "white",
				"--Chat-HeaderBackground": "#2463af",
				"--Chat-HeaderPictureBorderRadius": "6px",
				"--Chat-ChatboxBackgroundOwner": "#34567f",
				"--Chat-ChatboxColorOwner": "white",
				"--Chat-ChatboxBorderOwner": "none",
				"--Chat-ChatboxBorderRadiusOwner": "6px",
				"--Chat-ChatboxColorNotSupportOwner": "#929292",
				"--Chat-ChatboxBackgroundOther": "#efefef",
				"--Chat-ChatboxColorOther": "#615f5f",
				"--Chat-ChatboxBorderOther": "none",
				"--Chat-ChatboxBorderRadiusOther": "6px",
				"--Chat-ChatboxColorNotSupportOther": "#b1b1b1",
				"--Chat-TypingboxBackground": "#2463af",
				"--Chat-TypingboxColor": "white",
				"--Chat-QuickReplyButtonBorder": "#2463af",
				"--Chat-QuickReplyButtonBackground": "white",
				"--Chat-QuickReplyButtonColor": "#2463af",
				"--Chat-Icon-Active": "white",
				"--Chat-ColorCancel": "#f44336",
				// "--Chat-MainFontSize-All": this.$store.getters.mainFontSize,
				// "--Chat-SubFontSize-All": this.$store.getters.subFontSize,
				"--Chat-Height-Typer": "160px",
				"--Chat-Container": "100vh - 235px",
				"--Chat-MessageVideoError": "The media could not be loaded",
			},
			x_menu_input: 0,
			y_menu_input: 0,
			msgSend: '',
			tag_id: '',
			loading: false,
			list_mention: [],
			listfriend_filter: [],
			data_clipboard: null,
			eventDrop: false,
			ListFiles: [],
			WarningDialog: false,
			WarningDialogDetail: {},
			ErrorDialog: false,
			ErrorDialogDetail: {},
			ListBottomItem: [],
			menuInput: false,
			rows: 4, // เริ่มต้นที่ 4 แถว
			minRows: 4, // จำนวนแถวเริ่มต้น
			maxRows: 12, // จำนวนแถวสูงสุด (ตามต้องการ)
			maxCharsPerRow: 100,
			count: "plus",
			history: [], // ประวัติข้อความ
			currentIndex: -1, // ตำแหน่งปัจจุบันในประวัติ
			startPos: 0,
			endPos: 0,
			cursorPosition: null
		}
	},
	created() {
		// console.log('statusSendMsg =>', this.statusSendMsg);
		// check message ที่พิพม์ค้างไว้ในห้องแชท
		if (localStorage.getItem(`message-${this.$route.params.tokenroom}`) !== undefined && localStorage.getItem(`message-${this.$route.params.tokenroom}`) !== null) {
			this.msgSend = localStorage.getItem(`message-${this.$route.params.tokenroom}`)
		} else {
			this.msgSend = ""
		}
		this.$emit('emitComponents', {
			name: 'message',
			value: {
				data: this.msgSend,
			}
		})
	},
	watch: {
		emitEmoji() {
			// console.log("watch emitEmoji =>", this.emitEmoji);
			if (this.emitEmoji.count !== 0) {
				this.getCursorPosition();
			}
		},
		tokenroom() {
			// console.log("watch tokenroom", this.tokenroom);
			if (localStorage.getItem(`message-${this.$route.params.tokenroom}`) !== undefined && localStorage.getItem(`message-${this.$route.params.tokenroom}`) !== null) {
				this.msgSend = localStorage.getItem(`message-${this.$route.params.tokenroom}`)
			} else {
				this.msgSend = ""
			}
		},
		// new_msgSend() {
		// 	console.log(`box new_msgSend ${this.msgSend} =>`, this.new_msgSend);
		// 	// window.addEventListener("mouseup", this.focusTextBox);
		// 	// window.addEventListener("enter", this.focusTextBox);
		// 	// window.addEventListener("blur", this.focusTextBox);
		// 	// window.addEventListener("focus", this.onFocus);
		// 	this.getCursorPosition();
		// 	// this.msgSend = this.new_msgSend
		// },
		statusSendMsg() {
			// console.log(`watch statusSendMsg => ${this.statusSendMsg !== null}`, this.statusSendMsg);
			if (this.statusSendMsg !== null) {
				this.msgSend = ''
			}
		},
		msgSend(newVal, oldVal) {
			// this.$cookie.set(`message-${this.$route.params.tokenroom}`, this.msgSend)
			localStorage.setItem(`message-${this.$route.params.tokenroom}`, this.msgSend)
			// เฝ้าดูการเปลี่ยนแปลงของ message ถ้ามีการแก้ไข
			if (newVal !== oldVal) {
				this.saveToHistory();
			}
			this.checkContent();
			this.checkNewlines();
		},
	},
	mounted() {
		window.addEventListener("keydown", this.handleKeydown);
		// window.addEventListener("blur", this.focusTextBox);
		// window.addEventListener("focus", this.onFocus);
		if (localStorage.getItem(`message-${this.$route.params.tokenroom}`) !== undefined && localStorage.getItem(`message-${this.$route.params.tokenroom}`) !== null) {
			this.msgSend = localStorage.getItem(`message-${this.$route.params.tokenroom}`)
		} else {
			this.msgSend = ""
		}
	},
	beforeDestroy() {
		window.removeEventListener("keydown", this.handleKeydown);
		// window.removeEventListener("blur", this.focusTextBox);
		// window.addEventListener("focus", this.onFocus);
	},
	methods: {
		insertTextAtCursor(inputElement, text) {
			if (document.activeElement !== inputElement) {
				inputElement.focus();
			}
			const startPos = inputElement.selectionStart;
			const endPos = inputElement.selectionEnd;
			const originalValue = inputElement.value;

			inputElement.value =
				originalValue.substring(0, startPos) +
				text +
				originalValue.substring(endPos);
			
			this.msgSend = inputElement.value
			inputElement.setSelectionRange(startPos + text.length, startPos + text.length); // ย้าย cursor ไปหลังข้อความที่แทรก
		},
		// onFocus() {
		// 	// ดึงตำแหน่ง cursor ทันทีเมื่อโฟกัส
		// 	this.getCursorPosition();
		// },
		async getCursorPosition() {
			const mentionElement = this.$refs.textareaChat;
			const inputElement = mentionElement.$el.querySelector('textarea'); // หรือ input
			this.insertTextAtCursor(inputElement, this.emitEmoji.data)
		},
		// focusTextBox(event) {
		// 	// console.log("focus blur", event);
		// 	this.getCursorPosition();
		// },
		handleKeydown(event) {
			// console.log(event);
			this.handleKey(event)
			// ตรวจสอบว่าเป็น Mac หรือไม่
			const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;

			// ตรวจสอบ Ctrl + Z (Windows) หรือ Cmd + Z (Mac)
			if (
				(isMac && event.metaKey && event.key === 'z') ||
				(!isMac && event.ctrlKey && event.key === 'z')
			) {
				event.preventDefault(); // ป้องกันพฤติกรรม Undo เริ่มต้นของเบราว์เซอร์
				// this.undo();
				this.clearMessage(); // เรียกฟังก์ชันเคลียร์ข้อความ
			} else if (
				(isMac && event.metaKey && event.shiftKey && event.key === 'z') ||
				(!isMac && event.ctrlKey && event.shiftKey && event.key === 'z')
			) {
				event.preventDefault(); // ป้องกันพฤติกรรม Redo เริ่มต้นของเบราว์เซอร์
				this.redo();
			}
		},
		saveToHistory() {
			if (this.isUndoRedo) return; // หยุดถ้าเป็นการ undo/redo
			// ตรวจสอบว่ามีการบันทึกข้อความปัจจุบันไว้ในประวัติแล้วหรือยัง
			if (this.currentIndex === this.history.length - 1) {
				// ถ้ายัง ให้บันทึกข้อความปัจจุบันในประวัติ
				this.history.push(this.msgSend);
				this.currentIndex++;
			} else {
				// ถ้าไม่ ให้ลบประวัติที่เก่ากว่าแล้วบันทึกใหม่
				this.history = this.history.slice(0, this.currentIndex + 1);
				this.history.push(this.msgSend);
				this.currentIndex++;
			}
		},
		// undo() {
		//   if (this.currentIndex > 0) {
		//     this.isUndoRedo = true; // ตั้งเพื่อป้องกันการบันทึก
		//     this.currentIndex--;
		//     this.msgSend = this.history[this.currentIndex];
		//     this.isUndoRedo = false; // ปิดเมื่อ undo เสร็จ
		//   }
		// },
		clearMessage() {
			this.isUndoRedo = true;  // ตั้งธงป้องกันการบันทึก
			this.msgSend = '';       // เคลียร์ข้อความทั้งหมด
			this.history = [];       // ลบประวัติทั้งหมด
			this.currentIndex = -1;  // รีเซ็ตตำแหน่งประวัติ
			this.isUndoRedo = false; // ปิดธงเมื่อเสร็จสิ้น
			this.list_mention = [];
		},
		redo() {
			if (this.currentIndex < this.history.length - 1) {
				this.isUndoRedo = true; // ตั้งเพื่อป้องกันการบันทึก
				this.currentIndex++;
				this.msgSend = this.history[this.currentIndex];
				this.isUndoRedo = false; // ปิดเมื่อ redo เสร็จ
			}
		},
		checkContent() {
			// นับจำนวนตัวอักษรในข้อความ
			const charCount = this.msgSend.length;

			// คำนวณจำนวนแถวที่ต้องใช้ (หารความยาวของข้อความด้วยจำนวนตัวอักษรที่รองรับใน 1 แถว)
			const calculatedRows = Math.ceil(charCount / this.maxCharsPerRow);

			// เพิ่ม rows ตามความยาวของข้อความ แต่ไม่เกิน maxRows
			this.rows = Math.min(Math.max(calculatedRows, this.minRows), this.maxRows);
			// console.log("this.rows =>", this.rows);
			if (this.rows <= 12) {
				this.$emit("emitMessageBox", {
					rows: this.rows,
					minRows: 4, // จำนวนแถวเริ่มต้น
					maxRows: 12,
					count: this.count
				})
			}
		},
		checkNewlines() {
			// console.log("checkNewlines");
			// นับจำนวน \n ในข้อความ
			const newlineCount = (this.msgSend.match(/\n/g) || []).length;
			// เพิ่ม row เมื่อ \n มากกว่า 4
			if (newlineCount > 4) {
				this.rows = Math.min(newlineCount + 1, this.maxRows); // จำกัดไม่เกิน maxRows
			} else {
				this.rows = this.minRows; // ตั้งค่า row กลับเป็นค่าเริ่มต้น
			}
			if (this.rows <= 12) {
				this.$emit("emitMessageBox", {
					rows: this.rows,
					minRows: 4, // จำนวนแถวเริ่มต้น
					maxRows: 12,
					count: this.count
				})
			}
		},
		handleKey(evt) {
			// console.log("evet => ", evt);
			// key delete
			if (evt.keyCode === 8) {
				// delete row
				this.count = "minus";
				this.checkNewlines()
			} else {
				if (evt.shiftKey && evt.keyCode === 13) {
					// add row
					this.count = "plus";
					this.checkNewlines()
				}
			}
		},
		focusMentions() {
			// ให้ cursor กลับมา focus ที่ `a-mentions`
			this.$refs.textareaChat.$el.querySelector('textarea').focus();
		},
		sendMessage(evt, data, item, msgType, resendType) {
			// console.log("evet => ", evt);
			this.$emit('emitComponents', {
				name: 'message',
				value: {
					data: this.msgSend,
				}
			})
			if (evt.shiftKey && evt.keyCode === 13) {
				// add row
				this.count = "plus";
				this.checkNewlines()
				// console.log("rows => ", this.rows);
			} else if (evt.keyCode === 13) {
				evt.preventDefault();
				this.$emit('emitComponents', {
					name: 'sendMsg',
					value: {
						data: this.list_mention.length !== 0 ? this.convertMsgMention(data, this.list_mention) : data,
						item: item,
						type: msgType,
						resend: resendType,
						mention: this.list_mention
					}
				})
				this.clearMessage()
				this.ListFiles = []
			}
		},
		convertMsgMention(msg, listmemtion) {
			for (var j = 0; j < listmemtion.length; j++) {
				if (listmemtion[j] !== undefined) {
					msg = msg.replace(('@' + listmemtion[j].name), '<tax>' + listmemtion[j].tokenuser + '</tax>')
				}
			}
			return msg
		},
		emitListBottom(item) {
			// console.log('emitListBottom => ', item);
			if (item.methods === 'paste-text') {
				this.onPasteText(item)
			} else if (item.methods === 'paste-file') {
				// this.convertFile(item.value)
				if (_.sum(item.value.size) / 1024 / 1024 > 1000) {
					this.ErrorDialogDetail = {
						title: 'Error',
						text: this.$t('Alert.Fail.Chat.maxSizeFile1000')
					}
					this.ErrorDialog = true
				} else {
					this.ListFiles.push({
						name: item.files.name,
						value: URL.createObjectURL(item.value),
						files: item.files,
						type: item.value.type,
						size: item.value.size
					})
					this.$emit('emitComponents', { name: 'on-paste', value: this.ListFiles })
					this.ListFiles = []
				}
			} else if (item.methods === 'paste-image-contextmenu') {
				this.WarningDialogDetail = {
					title: '',
					text: this.$t('Alert.Chat.pastImage', {
						name: 'on-paste'
					}),
					detail: {
						methods: 'paste-image-contextmenu',
						files: item.files,
						text: item.excel_text
					},
				}
				this.WarningDialog = true
			}
		},
		onPasteText(data) {
			// console.log("onPasteText");
			if (this.msgSend !== '') {
				const divTextarea = document.getElementById('textsendmsg')
				const textarea = data.events.target;
				const currentValue = textarea.value;
				const startPos = data.events.target.selectionStart;
				const endPos = data.events.target.selectionEnd;
				const textToInsert = data.value
				const newValue = currentValue.slice(0, startPos) + textToInsert + currentValue.slice(endPos);
				textarea.value = newValue;
				divTextarea.setSelectionRange(startPos + textToInsert.length, startPos + textToInsert.length);
				divTextarea.focus();
				this.msgSend = newValue
			} else {
				if (data.value) {
					this.msgSend = data.value
				}
			}
		},
		async showMenuInput(e) {
			e.preventDefault()
			this.menuInput = false
			this.data_clipboard = e
			this.x_menu_input = e.clientX
			this.y_menu_input = e.clientY
			this.ListBottomItem = []
			const clipboardContents = await navigator.clipboard.read();
			for (const item of clipboardContents) {
				if (!item.types.includes("image/png")) {
					// copy text
					const blobs = await item.getType("text/plain");
					// console.log("non-image data");
					navigator.clipboard.readText()
						.then(text => {
							if (text) {
								this.ListBottomItem.push({
									text: this.$t('ChatSide.RightClickMenu.paste'),
									methods: 'paste-text',
									icon: '',
									value: text,
									disabled: false,
									events: e
								})
							} else {
								this.ListBottomItem.push({
									text: this.$t('ChatSide.RightClickMenu.paste'),
									methods: 'paste-text',
									icon: '',
									value: text,
									disabled: true,
									events: e
								})
							}
						})
				} else {
					var data = _.filter(item.types, function (o) { return o === 'text/plain' })
					if (data.length !== 0) {
						// copy excel
						const excel_blob = await item.getType("image/png");
						var excel_file = new File([excel_blob], 'image.png')
						var excel_text = ''
						navigator.clipboard.readText()
							.then(text => {
								if (text) {
									excel_text = text
									this.ListBottomItem.push({
										text: this.$t('ChatSide.RightClickMenu.paste'),
										methods: 'paste-image-contextmenu',
										icon: '',
										value: excel_blob,
										disabled: false,
										events: e,
										files: excel_file,
										excel_text: excel_text
									})
								}
							})
					} else {
						// copy image in chat
						const blob = await item.getType("image/png");
						var file = new File([blob], 'image.png')
						this.ListBottomItem.push({
							text: this.$t('ChatSide.RightClickMenu.paste'),
							methods: 'paste-file',
							icon: '',
							value: blob,
							disabled: false,
							events: e,
							files: file
						})
					}
				}
			}

			this.$nextTick(() => {
				this.menuInput = true
			})
		},
		closeAlertDialog(item) {
			// console.log(item)
			if (item.type === 'bottommenu') {
				// this.ListBottomItem = []
				// this.ListBottomMenu = item.value
			} else if (item.type === 'err') {
				this.ErrorDialog = item.value
			} else if (item.type === 'warning') {
				this.WarningDialog = item.value
			}
		},
		emitWarning(item) {
			// console.log('emitWarning => ', item);
			this.WarningDialog = false
			if (item.detail.methods === 'paste-image') {
				if (item.type === 'image') {
					// อยู่ในกลุ่มและเป็นเพื่อน
					if (this.statemember) {
						this.convertFile(item.detail.files)
					}
				} else {
					// วาง text เป็นไฟล์ทั่วไป จะเอาชื่อไฟล์มาแสดงแทน
					if (item.detail.files.length !== 0 && item.detail.text === '') {
						var name = _.map(item.detail.files, 'name')
						var new_name = name.join('\n')
						if (this.msgSend !== '') {
							if (this.data_clipboard !== null) {
								const divTextarea = document.getElementById('textsendmsg')
								const textarea = this.data_clipboard.target;
								const currentValue = textarea.value;
								const startPos = textarea.selectionStart;
								const endPos = textarea.selectionEnd;
								const textToInsert = new_name
								const newValue = currentValue.slice(0, startPos) + textToInsert + currentValue.slice(endPos);
								textarea.value = newValue;
								divTextarea.setSelectionRange(startPos + textToInsert.length, startPos + textToInsert.length);
								divTextarea.focus();
								this.msgSend = newValue
							}

						} else {
							this.msgSend = new_name
						}
					} else {
						// วางข้อความปกติ
						if (this.msgSend !== '') {
							if (this.data_clipboard !== null) {
								const divTextarea = document.getElementById('textsendmsg')
								const textarea = this.data_clipboard.target;
								const currentValue = textarea.value;
								const startPos = textarea.selectionStart;
								const endPos = textarea.selectionEnd;
								const textToInsert = item.detail.text
								const newValue = currentValue.slice(0, startPos) + textToInsert + currentValue.slice(endPos);
								textarea.value = newValue;
								divTextarea.setSelectionRange(startPos + textToInsert.length, startPos + textToInsert.length);
								divTextarea.focus();
								this.msgSend = newValue
							}
						} else {
							if (item.detail.text) {
								this.msgSend = item.detail.text
							}
						}
					}
				}
			} else if (item.detail.methods === 'paste-image-contextmenu') {
				if (item.type === 'image') {
					// อยู่ในกลุ่มและเป็นเพื่อน
					if (this.statemember) {
						if (_.sum(item.detail.files.size) / 1024 / 1024 > 1000) {
							this.ErrorDialogDetail = {
								title: 'Error',
								text: this.$t('Alert.Fail.Chat.maxSizeFile1000')
							}
							this.ErrorDialog = true
						} else {
							this.ListFiles.push({
								name: item.detail.files.name,
								value: URL.createObjectURL(item.detail.files),
								files: item.detail.file,
								type: item.detail.type,
								size: item.detail.size
							})
							this.$emit('emitComponents', { name: 'on-paste', value: this.ListFiles })
							this.ListFiles = []
						}
					}
				} else {
					// วาง text เป็นไฟล์ทั่วไป จะเอาชื่อไฟล์มาแสดงแทน
					if (item.detail.files.length !== 0 && item.detail.text === '') {
						var name = _.map(item.detail.files, 'name')
						var new_name = name.join('\n')
						if (this.msgSend !== '') {
							if (this.data_clipboard !== null) {
								const divTextarea = document.getElementById('textsendmsg')
								const textarea = this.data_clipboard.target;
								const currentValue = textarea.value;
								const startPos = textarea.selectionStart;
								const endPos = textarea.selectionEnd;
								const textToInsert = new_name
								const newValue = currentValue.slice(0, startPos) + textToInsert + currentValue.slice(endPos);
								textarea.value = newValue;
								divTextarea.setSelectionRange(startPos + textToInsert.length, startPos + textToInsert.length);
								divTextarea.focus();
								this.msgSend = newValue
							}
						} else {
							this.msgSend = new_name
						}
					} else {
						// วางข้อความปกติ
						if (this.msgSend !== '') {
							if (this.data_clipboard !== null) {
								const divTextarea = document.getElementById('textsendmsg')
								const textarea = this.data_clipboard.target;
								const currentValue = textarea.value;
								const startPos = textarea.selectionStart;
								const endPos = textarea.selectionEnd;
								const textToInsert = item.detail.text
								const newValue = currentValue.slice(0, startPos) + textToInsert + currentValue.slice(endPos);
								textarea.value = newValue;
								divTextarea.setSelectionRange(startPos + textToInsert.length, startPos + textToInsert.length);
								divTextarea.focus();
								this.msgSend = newValue
							}
						} else {
							if (item.detail.text) {
								this.msgSend = item.detail.text
							}
						}
					}
				}
			}
		},
		onPaste(evt) {
			this.data_clipboard = evt
			var items = []
			items = evt.clipboardData.items
			var me = this
			var list_file = []
			// copy excel และมี text ติดมาด้วย จะไม่วาง text ก่อน
			if (evt.clipboardData.getData('text') && items.length !== 0) {
				// this.msgSend = this.msgSend + ''
				for (var i = 0; i < items.length; i++) {
					// copy excel
					if (evt.clipboardData.getData('text') !== '' && items[i].type.indexOf('image') !== -1) {
						var file = items[i].getAsFile();
						if (file !== undefined && file !== null) {
							list_file.push(file)
						}
						if (i === items.length - 1) {
							this.WarningDialogDetail = {
								title: '',
								text: this.$t('Alert.Chat.pastImage', {
									name: 'on-paste'
								}),
								detail: {
									methods: 'paste-image',
									files: list_file,
									text: evt.clipboardData.getData('text')
								},
							}
							this.WarningDialog = true

							if (me.msgSend !== '') {
								me.msgSend = me.msgSend + ''
							} else {
								me.msgSend = ''
							}
						}
					} else {
						if (i === items.length - 1) {
							if (list_file.length === 0) {
								if (me.msgSend !== '') {
									const divTextarea = document.getElementById('textsendmsg')
									const textarea = event.target;
									const currentValue = textarea.value;
									const startPos = event.target.selectionStart;
									const endPos = event.target.selectionEnd;
									const textToInsert = event.clipboardData.getData('text')
									const newValue = currentValue.slice(0, startPos) + textToInsert + currentValue.slice(endPos);
									textarea.value = newValue;
									divTextarea.setSelectionRange(startPos + textToInsert.length, startPos + textToInsert.length);
									divTextarea.focus();
									this.msgSend = newValue
								} else {
									if (evt.clipboardData.getData('text')) {
										me.msgSend = evt.clipboardData.getData('text')
									}
								}
							} else {
								this.msgSend = this.msgSend + ''
							}
						}
					}
				}
			} else {
				for (var i = 0; i < items.length; i++) {
					// copy excel
					if (evt.clipboardData.getData('text') !== '' && items[i].type.indexOf('image') !== -1) {
						var file = items[i].getAsFile();
						if (file !== undefined && file !== null) {
							list_file.push(file)
						}
						if (i === items.length - 1) {
							this.WarningDialogDetail = {
								title: '',
								text: this.$t('Alert.Chat.pastImage', {
									name: 'on-paste'
								}),
								detail: {
									methods: 'paste-image',
									files: list_file,
									text: evt.clipboardData.getData('text')
								},
							}
							this.WarningDialog = true
						}
					} else if (evt.clipboardData.getData('text') === '' && items[i].type.indexOf('image') !== -1) {
						// copy file or image
						var file = items[i].getAsFile();
						if (file !== undefined && file !== null) {
							list_file.push(file)
						}
						// วางเลย ไม่ต้องแสดง dialog ถามว่าจะวางรูปหรือไฟล์
						if (i === items.length - 1) {
							this.convertFile(list_file)
						}
					} else if (evt.clipboardData.getData('text') === '' && items[i].type.indexOf('image') === -1) {
						var file = items[i].getAsFile();
						if (file !== undefined && file !== null) {
							list_file.push(file)
						}
						if (i === items.length - 1) {
							// อยู่ในกลุ่มและเป็นเพื่อน
							if (this.statemember) {
								this.convertFile(list_file)
							}
						}
					} else {
						if (me.msgSend !== '') {
							me.msgSend = me.msgSend + evt.clipboardData.getData('text')
						} else {
							if (evt.clipboardData.getData('text')) {
								me.msgSend = evt.clipboardData.getData('text')
							}
						}
					}
				}
			}
		},
		async convertFile(data) {
			this.eventDrop = false
			var sizefile = []
			for (var i = 0; i < data.length; i++) {
				sizefile[i] = data[i].size
			}
			for (var i = 0; i < data.length; i++) {
				if (data[i].name !== null) {
					if (_.sum(sizefile) / 1024 / 1024 > 1000) {
						this.ErrorDialogDetail = {
							title: 'Error',
							text: this.$t('Alert.Fail.Chat.maxSizeFile1000')
						}
						this.ErrorDialog = true
					} else {
						this.ListFiles.push({
							name: data[i].name,
							value: URL.createObjectURL(data[i]),
							files: data[i],
							type: data[i].type,
							size: data[i].size
						})
					}
				} else {
					if (_.sum(sizefile) / 1024 / 1024 > 1000) {
						this.ErrorDialogDetail = {
							title: 'Error',
							text: this.$t('Alert.Fail.Chat.maxSizeFile1000')
						}
						this.ErrorDialog = true
					} else {
						this.ListFiles.push({
							name: 'image.png',
							value: URL.createObjectURL(data[i]),
							files: data[i],
							type: data[i].type,
							size: data[i].size
						})
					}
				}
			}
			this.$emit('emitComponents', { name: 'on-paste', value: this.ListFiles })
		},
		setDefaultImageChat(id) {
			var img = document.getElementById(`imgprofilechat-${id}`);
			img.src = `${require(`${this.publicPath}/assets/img/default_profile/man-white.png`)}`
			img.alt = "Default Image Alt Text";
		},
		onSelect(option) {
			// console.log('onSelect -> ', option);
			this.tag_id = `-${option.children[1].elm.id}`
			var tag_name = option.value.split('-')[0]
			const searchStrings = option.value;
			const startIndex = this.msgSend.indexOf(searchStrings) // หา index mention เพื่อเรียง list_mention
			this.list_mention.push({
				index: startIndex,
				name: tag_name,
				tokenuser: option.children[1].elm.id
			})
			this.list_mention = _.sortBy(this.list_mention, ['index'])
			const searchString = this.tag_id;
			this.msgSend = this.msgSend.replace(new RegExp(searchString, 'g'), '');
		},
		onSearch(search) {
			// console.log("listfriend", this.listfriend);
			if (this.typeRoom === 'group') {
				// console.log('onSearch -> ', search);
				this.search = search;
				this.loading = true;
				if (!search) {
					// If the search query is empty, reset the filtered list to show all members
					this.listfriend_filter = this.listfriend;
					this.loading = false;
					return;
				}
				// Filter members based on the search query
				this.listfriend_filter = this.listfriend.filter(user =>
					// this.app_lang === "en" && user.name_eng !== "" ? user.name_eng.toLowerCase().includes(search.toLowerCase()) :
					// 	user.name.toLowerCase().includes(search.toLowerCase())
					user.name.toLowerCase().includes(search.toLowerCase())
				);
				this.loading = false;
			}
		},
	},
}
</script>

<style lang="css" scoped>
>>>.ant-mentions>textarea {
	width: 100% !important;
	border: none !important;
	outline: none !important;
	resize: none !important;
	color: #000000 !important;
}

.messageBox {
	width: -webkit-fill-available !important;
	box-sizing: border-box;
	display: flex;
	align-items: center;
	bottom: 0;
	height: var(--Chat-Height-Typer);
	background: var(--Chat-TypingboxBackground) !important;
	box-shadow: none;
	justify-content: center;
	padding-left: 10px;
	padding-right: 10px;
	position: fixed;
}
</style>